import React from 'react'
import { getFormattedDate } from '../../../../common/services/common.service'
import moment from 'moment'
export default function ParcelConfirmComponent({ quoteDetails, leadDetails }: any) {

    return (

        <div className="w-full">
            <div className="mb-6 ">
                <h1> Order  Summary Details</h1>

            </div>
            <table className="w-full  font-semibold text-sm lg:text-base">
                <tfoot>
                    <tr >
                        <td className="p-4 italic">{"Amount Quoted "}</td>
                        <td className="p-4"> {quoteDetails?.result?.Records[0]?.message?.order?.quote?.breakup[0]?.price?.value}</td>
                    </tr>
                    <tr >
                        <td className="p-4 italic">{"Relocation Date"}</td>
                        <td className="p-4">
                            {leadDetails?.quoteData?.date ? getFormattedDate(leadDetails?.quoteData?.date) : moment().format('YYYY-MM-DD h:mm:ss a')}
                            {/* <span className="text-[13px] font-normal ps-1.5 inline-block">
                 via Flat rate
               </span> */}
                        </td>
                    </tr>
                    <tr >
                        <td className="p-4 italic">{"Service Type"}</td>
                        <td className="p-4">{"Standard"}</td>
                    </tr>
                    <tr >
                        <td className="p-4 italic">{"No of items added"}</td>
                        <td className="p-4">{quoteDetails?.result?.Records[0]?.message?.order?.LinkedItems?.length}</td>
                    </tr>


                    {/* <tr className="odd:bg-skin-secondary">
             <td className="p-4 italic">{useLocale('common', 'text-note')}:</td>
             <td className="p-4">{useLocale('common', 'text-new-order')}</td>
           </tr> */}
                </tfoot>
            </table>
        </div>



    )
}